import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendSelectClickSoundCommand } from '../../../helpers/web_to_client'

import styles from './TableBodyCell.css'

const TYPES = [
    'arrow',
    'check',
    'number',
    'role',
    'basis',
    'basisGutter',
]

const ALIGNMENTS = {
    right: 'alignRight',
    left: 'alignLeft',
    center: 'alignCenter',
}

const propTypes = {
    children: PropTypes.node,
    type: PropTypes.oneOf(TYPES),
    alignment: PropTypes.oneOf(Object.keys(ALIGNMENTS)),
    valueType: PropTypes.oneOf(['null', 'positive', 'resource']),
    valueWidth: PropTypes.string,
    isValue: PropTypes.bool,
    isError: PropTypes.bool,
    isOwn: PropTypes.bool,
    isFluid: PropTypes.bool,
    tooltipId: PropTypes.string,
    tooltipTip: PropTypes.string,
    onContextMenu: PropTypes.func,
}

const defaultProps = {
    valueWidth: null,
    tooltipTip: 'true',
}

const TableBodyCell = (props) => {
    const classNameBase = classNames(styles.td, {
        [styles[`td__${props.type}`]]: props.type,
        [styles[`td__${ALIGNMENTS[props.alignment]}`]]: props.alignment,
        [styles.td__isFluid]: props.isFluid,
    })

    const classNameValue = classNames(styles.tdValue, {
        [styles[`tdValue____${props.valueType}`]]: props.valueType,
        [styles.tdValue__isValue]: props.isValue,
        [styles.tdValue__isError]: props.isError,
        [styles.tdValue__isOwn]: props.isOwn,
    })

    const dataAttrs = props.tooltipId ? {
        'data-tip': props.tooltipTip,
        'data-for': props.tooltipId,
    } : {}

    const handleMouseDown = props.onContextMenu ? (e) => {
        if (e.button === 2) {
            sendSelectClickSoundCommand()
            e.stopPropagation()
        }
    } : null

    const styleValue = props.valueWidth ? { width: `${props.valueWidth}px` } : null

    return (
        <div
            className={classNameBase}
            onMouseDown={handleMouseDown}
            onContextMenu={props.onContextMenu}
        >
            <div
                className={classNameValue}
                style={styleValue}
                {...dataAttrs}
            >
                {props.children}
            </div>
        </div>
    )
}

TableBodyCell.propTypes = propTypes
TableBodyCell.defaultProps = defaultProps

export default TableBodyCell



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Table/TableBodyCell/TableBodyCell.jsx